import { NumberInput } from 'carbon-components-react';
import React, { MutableRefObject, useEffect, useRef } from 'react';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import { segmentsTracking } from 'src/common/lib/tracker';

type Step7Props = {
  que7Value: number;
  setQue7Value: React.Dispatch<React.SetStateAction<number>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  useTranslation: TranslationFunction;
};

const Step7 = ({
  que7Value,
  setQue7Value,
  setIsRequired,
  useTranslation,
}: Step7Props) => {
  const deviceRef = useRef() as MutableRefObject<HTMLInputElement>;

  useEffect(() => {
    if (Number(que7Value) !== 0) {
      setIsRequired(false);
    } else {
      setIsRequired(true);
    }
  }, [que7Value]);

  return (
    <div>
      <label className="page_sub_heading padding_8">
        {useTranslation('que7_text_desc')}
      </label>
      <p>{useTranslation('que7_short_desc')}</p>
      <div className="number-input">
        <NumberInput
          id="Q7"
          size="md"
          ref={deviceRef}
          allowEmpty={true}
          name="Q7"
          helperText="Please add numbers of devices"
          min={0}
          max={50000}
          step={10}
          value={que7Value ? que7Value : ''}
          invalidText="Please provide a number between 1-50000"
          onChange={() => {
            if (deviceRef.current.value === '') {
              setIsRequired(true);
            } else {
              setQue7Value(parseInt(deviceRef.current.value));
              segmentsTracking('CTA Clicked', {
                pageTitle: 'MaaS360 Plan Assessment',
                object: 'Mass360 page',
                resultValue: 'CTA clicked',
                CTA: `question 7 - ${parseInt(
                  deviceRef.current.value,
                )} - selected`,
                location: 'Assessment',
                action: '',
                field: '',
              });
              setIsRequired(false);
            }
          }}
        />
      </div>
    </div>
  );
};

export default Step7;
